export const formatDateForInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const generateReportOptions = (facilityItems) => {
  if (!facilityItems || !Array.isArray(facilityItems)) return {
    itemNames: [],
    modelNos: [],
    categories: [],
    locations: [],
    statuses: []
  };

  const itemNames = [...new Set(facilityItems.map(item => item.name))];
  const modelNos = [...new Set(facilityItems.map(item => item.modelNo))];
  const categories = [...new Set(facilityItems.map(item => item.category?.name || ''))].filter(Boolean);
  const locations = [...new Set(facilityItems.map(item => item.locationDetails?.room || ''))].filter(Boolean);
  const statuses = [...new Set(facilityItems.map(item => item.status))];

  return {
    itemNames: itemNames.sort(),
    modelNos: modelNos.sort(),
    categories: categories.sort(),
    locations: locations.sort(),
    statuses: statuses.sort()
  };
};